// extracted by mini-css-extract-plugin
export default {"canvasContainer":"style_canvasContainer__4x6Pv","canvas":"style_canvas__cT9wJ"};